import { Box, styled } from '@mui/material';

export const ProductCardGrid = styled(Box)`
  height: 77vh;
  overflow-y: auto;
`;
